<div [class]="ie.Attributes.AssignedColumnWidth">
  <div class="text-end">
    <button class="btn btn-warning btn-sm" *ngIf="uxControllerService.RTKeyAllowDynaEdit" (click)="uxControllerService.openDynaEditor(ie)">
      <i id="button_DynaEdit"></i>
    </button>
  
  </div>
<div *ngIf="(headline != '')" style="padding: 0px 20px 20px 0px; font-weight: bold;">{{headline}}</div>
<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs"  (navChange)="onNavChange($event)" >
  <li *ngFor="let ieTab of ieTabs" [ngbNavItem]="ieTab.InterfaceElementID" >
    <a ngbNavLink>{{ ieTab.Label.DisplayName }}</a>
    <ng-template ngbNavContent>
      <ng-container *ngIf="(ie.CustomizeOptions != null && ie.CustomizeOptions.DisplayType == 'custom') || (ieTab.CustomizeOptions != null && ieTab.CustomizeOptions.DisplayType == 'custom')">
        <ng-container *ngTemplateOutlet="wizardTemplateCustom;context:{IELIST: ieTab, FORMGROUP : ieTab.InterfaceElementGroup}">
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(ie.CustomizeOptions == null && ieTab.CustomizeOptions == null)">
        <ng-container *ngTemplateOutlet="wizardTemplate;context:{IELIST: ieTab, FORMGROUP : ieTab.InterfaceElementGroup}">
        </ng-container>
      </ng-container>
    </ng-template>
  </li>
  
</ul>

<div [ngbNavOutlet]="nav" class="mt-2"></div>
<!--<tabset>
    <tab *ngFor="let ieTab of ieTabs" [heading]="ieTab.Label.DisplayName" [disabled]="!ieTab.Attributes.Enabled" [active]="ieTab.Attributes.Active">
      <ng-container *ngIf="(ie.CustomizeOptions != null && ie.CustomizeOptions.DisplayType == 'custom') || (ieTab.CustomizeOptions != null && ieTab.CustomizeOptions.DisplayType == 'custom')">
        <ng-container *ngTemplateOutlet="wizardTemplateCustom;context:{IELIST: ieTab, FORMGROUP : ieTab.InterfaceElementGroup}">
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(ie.CustomizeOptions == null && ieTab.CustomizeOptions == null)">
        <ng-container *ngTemplateOutlet="wizardTemplate;context:{IELIST: ieTab, FORMGROUP : ieTab.InterfaceElementGroup}">
        </ng-container>
      </ng-container>
    </tab>
</tabset>-->
</div>

<ng-template #wizardTemplate let-interfaceElementList="IELIST" let-group="FORMGROUP">
  <div #Tab class="col-md-12 form-group group-spacing"  [id]="'Group' + interfaceElementList.Attributes.DisplayOrder"  [formGroup]="group">
    <ng-container *ngFor="let ie of interfaceElementList.InterfaceElements;let i = index">
     
      <div class="form-group row" *ngIf="(ie.Attributes.Visible)" >
        
        <label class="col-sm-3 col-form-label-sm" [attr.for]="ie.InterfaceElementID">
          
           <ng-container  *ngIf="(ie.DisplayProperties.IsDisplayOnUI == true)"> {{ie.DisplayProperties.DisplayName}}</ng-container>
        </label>
        <div class="col-sm-1">
          <app-cosy-checkbox *ngIf="(ie.Attributes.Nullable && ie.Values.length > 0 && RTKeyShowNullable == 'true')" [nullValue]="true" [ie]="ie" [formgroup]="group"></app-cosy-checkbox>
          <div *ngIf="(ie.CustomizeOptions  != null  && ie.CustomizeOptions.DisplayType == 'document' && ie.CustomizeOptions.Mode != 'withoutUpload')" class="icon-display-position">
            <button class="btn btn-light" (click)="showNdownloadPDF(ie.documentID,ie.value,'show' )">
              <i id="button_Pdf"></i>
            </button>
            <button class="btn btn-light" (click)="showNdownloadPDF(ie.documentID,ie.value,'download')">
              <i id="button_FileDownload"></i>
            </button>
          </div>
        </div>
        <div class="col-sm-7">
          <app-cosy-inputtext *ngIf="(ie.TypeDID == IE_TYPES.InputText) || (ie.TypeDID == IE_TYPES.InputNumber) || (ie.TypeDID == IE_TYPES.InputDate) " [ie]="ie" [formgroup]="group"></app-cosy-inputtext>
          <app-cosy-picklist *ngIf="(ie.TypeDID == IE_TYPES.InputPicklist)" [ie]="ie" [formType]="interfaceElementList.TypeDID"  [formgroup]="group" [RTKeyShowNullable]=RTKeyShowNullable></app-cosy-picklist>
          <app-cosy-checkbox *ngIf="(ie.TypeDID == IE_TYPES.InputBoolean)" [ie]="ie" [formgroup]="group" [RTKeyShowNullable]=RTKeyShowNullable></app-cosy-checkbox>
          <app-cosy-trigger *ngIf="(ie.TypeDID == IE_TYPES.Trigger)" [ie]="ie"></app-cosy-trigger>
          <app-cosy-grid *ngIf="(ie.TypeDID == IE_TYPES.EntityList)" [ie]="ie" [formgroup]="group"></app-cosy-grid>
          <app-cosy-label *ngIf="(ie.TypeDID == IE_TYPES.Label)" [ie]="ie"></app-cosy-label>
          <app-cosy-validatormessage *ngIf="ie.Messages?.length > 0" [ie]="ie" [formgroup]="group"></app-cosy-validatormessage>
        </div>
        <div style="display: none" >
          <button class="btn btn-warning btn-sm" *ngIf="(i == 0) && (uxControllerService.RTKeyAllowDynaEdit)" (click)="openDynaEditor(interfaceElementList,dynaEditorTemplate)">
            <i id="button_DynaEdit"></i>
        </button>
        </div>
        <div style="display:none" [id]="ie.documentID" class="col-sm-11 top-buffer" *ngIf="(ie.type == IE_TYPES.InputText) && (ie.cosydatatypeID == IE_COSY_TYPES.InputTextCosyDataTypeID)">
          <!--object [data]="pdfURLBlob" width="100%" height="500" [type]="ie.customDisplayTypes.document.type">
          </object-->
          <ngx-extended-pdf-viewer 
          [base64Src]="pdfBase64" 
          [showOpenFileButton]=false
          [showBookmarkButton]=false
          [showSecondaryToolbarButton]=true
          [showSpreadButton]=false
          [showPropertiesButton]=false
          [showSidebarButton]=false
          [showScrollingButton]=false
          [(zoom)]=uxControllerService.zoom  
          [(rotation)]=uxControllerService.rotation 
          [(page)]=uxControllerService.page 
          [delayFirstView]="1000"
          [useBrowserLocale]="true" height="90vh"></ngx-extended-pdf-viewer>
       </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #wizardTemplateCustom let-interfaceElementList="IELIST" let-group="FORMGROUP">
    <div #Tab class="col-md-12 form-group group-spacing" [id]="'Group' + interfaceElementList.Attributes.DisplayOrder" [formGroup]="group">
    <ng-container *ngFor="let ie of interfaceElementList.InterfaceElements;let i = index">
      <div [id]="ie.ObjectName != null ? ie.ObjectName + ie.Attributes.DisplayOrder : ie.Name + ie.Attributes.DisplayOrder" class="form-group">
        <div *ngIf="(ie.Attributes.Visible)">
        <label [id]="ie.ObjectName != null ? 'Label' + ie.ObjectName + ie.Attributes.DisplayOrder : 'Label' + ie.Name + ie.Attributes.DisplayOrder" 
          style="display: block" class="col-form-label-sm" [attr.for]="ie.InterfaceElementID" *ngIf="(ie.PreLabel!=null)">
            {{ie.PreLabel.DisplayName}}
        </label>
        <div id="UploadDownLoad" class="">
          <div *ngIf="(ie.CustomDisplayTypes != null && ie.CustomDisplayTypes.document?.length)" class="icon-display-position">
            <button class="btn btn-light" (click)="showNdownloadPDF(ie.documentID,ie.value,'show' )">
              <i id="button_Pdf"></i>
            </button>
            <button class="btn btn-light" (click)="showNdownloadPDF(ie.documentID,ie.value,'download')">
              <i id="button_FileDownload"></i>
            </button>
          </div>
        </div>
        <div [id]="ie.ObjectName != null ? 'IE' + ie.ObjectName + ie.Attributes.DisplayOrder : 'IE' + ie.Name + ie.Attributes.DisplayOrder" class="">
          <app-cosy-inputtext *ngIf="(ie.TypeDID == IE_TYPES.InputText) || (ie.type == IE_TYPES.InputNumber) || (ie.type == IE_TYPES.InputDate) " [ie]="ie" [formgroup]="group"></app-cosy-inputtext>
          <app-cosy-validatormessage *ngIf="ie.MessageList?.length > 0" [ie]="ie" [formgroup]="group"></app-cosy-validatormessage>
          <app-cosy-picklist *ngIf="(ie.TypeDID == IE_TYPES.InputPicklist)" [ie]="ie" [formType]="interfaceElementList.TypeDID" [formgroup]="group"></app-cosy-picklist>
          <app-cosy-checkbox *ngIf="(ie.TypeDID == IE_TYPES.InputBoolean)" [ie]="ie" [formgroup]="group"></app-cosy-checkbox>
          <app-cosy-trigger *ngIf="(ie.TypeDID == IE_TYPES.Trigger)" [ie]="ie"></app-cosy-trigger>
          <app-cosy-grid *ngIf="(ie.TypeDID == IE_TYPES.EntityList)" [ie]="ie" [formgroup]="group"></app-cosy-grid>
          <app-cosy-label *ngIf="(ie.TypeDID == IE_TYPES.Label)" [ie]="ie"></app-cosy-label>
        </div>
        <div id="dynaEdit" style="display: none" class="">
          <button class="btn btn-warning btn-sm" *ngIf="(i == 0) && (uxControllerService.RTKeyAllowDynaEdit)" (click)="openDynaEditor(interfaceElementList,dynaEditorTemplate)">
            <i id="button_DynaEdit"></i>
        </button>
        </div>
        
        <div style="display:none" [id]="ie.documentID" class="col-sm-11 top-buffer" *ngIf="(ie.type == IE_TYPES.InputText) && (ie.cosydatatypeID == IE_COSY_TYPES.InputTextCosyDataTypeID)">
          <!--object [data]="pdfURLBlob" width="100%" height="500" [type]="ie.customDisplayTypes.document[0].type">
          </object-->
          <ngx-extended-pdf-viewer 
          [base64Src]="pdfBase64" 
          [showOpenFileButton]=false
          [showBookmarkButton]=false
          [showSecondaryToolbarButton]=true
          [showSpreadButton]=false
          [showPropertiesButton]=false
          [showSidebarButton]=false
          [showScrollingButton]=false
          [(zoom)]=uxControllerService.zoom  
          [(rotation)]=uxControllerService.rotation 
          [(page)]=uxControllerService.page 
          [delayFirstView]="1000"
          [useBrowserLocale]="true" height="90vh"></ngx-extended-pdf-viewer>
       </div>
       </div>
      </div>
    </ng-container>
  </div>
</ng-template>
